module.exports = __webpack_public_path__ + "static/img/6.2e80d19.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/eng/6.png
// module id = nljY
// module chunks = 0